import React from 'react';
import PropTypes from 'prop-types';
import { LabelSmall } from '@styled';

const LinkCTA = ({ Icon, className = '', href, text, onClick, ...props }) => (
    <a href={href} className={`align-items-center d-flex flex-column ${className}`} onClick={onClick} {...props}>
        <Icon iconClasses="mb-2" />
        <LabelSmall className="text-secondary">{text}</LabelSmall>
    </a>
);

LinkCTA.propTypes = {
    Icon: PropTypes.elementType.isRequired,
    className: PropTypes.string,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default LinkCTA;
